import React from 'react';
import { View, StyleSheet } from 'react-native';
import OpeningPerformanceReport from '@/Components/OpeningPerformanceReport';
import CCColors from '@/Utils/CCColors';

import { useNavigation } from '@react-navigation/native';
import { ScreenName } from '@/navigators/StackConstants';

const OpeningPerformanceReportScreen: React.FC = () => {
  const navigation = useNavigation();

  return (
    <View style={styles.container}>
      <View style={styles.reportContainer}>
        <OpeningPerformanceReport
          onBackPress={() => {
            navigation.navigate(ScreenName.Dashboard as never)
          }}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    backgroundColor: CCColors.Primary.Light,
    justifyContent: 'center'
  },
  reportContainer: {
    width: '70%',
  }

});

export default OpeningPerformanceReportScreen;